import React, { useRef } from "react";
import AppelAction from "../../components/AppelAction";
import SEOHead from "../../components/SEOHead";

// import styles from "./Features.module.sass";
import HeroOpco from "./HeroOpco";
import FonctionnalitesContrat from "./FonctionnalitesContrat";
import SolutionFacturation from "./SolutionFacturation";
import SolutionInterconnexion from "./SolutionInterconnexion";
import Faq from "./Faq";
import ProcessusOpco from "./ProcessusOpco";

const Opco = () => {
  const scrollToRef = useRef(null);

  const seoData = {
    title: "Intégration OPCO - Validation automatisée des dossiers de formation | Edutio",
    description: "Intégration native avec tous les OPCO. Validation automatisée des dossiers, suivi des financements et conformité réglementaire garantie pour votre CFA.",
    keywords: "OPCO, validation dossiers, financement formation, conformité CFA, intégration OPCO, facturation automatique"
  };

  return (
    <>
      <SEOHead {...seoData} />
      <HeroOpco  scrollToRef={scrollToRef} />
      <ProcessusOpco scrollToRef={scrollToRef} />
      
      <SolutionInterconnexion />
      <SolutionFacturation />

      <FonctionnalitesContrat />
      <Faq />
      <AppelAction className="section" />
    </>
  );
};

export default Opco;
